/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Breadcrumb_HomeInputs */

const es_seo_breadcrumb_home = /** @type {(inputs: Seo_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const gl_seo_breadcrumb_home = /** @type {(inputs: Seo_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const en_seo_breadcrumb_home = /** @type {(inputs: Seo_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Seo_Breadcrumb_HomeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_breadcrumb_home = /** @type {((inputs?: Seo_Breadcrumb_HomeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Breadcrumb_HomeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_seo_breadcrumb_home(inputs)
	if (locale === "en") return en_seo_breadcrumb_home(inputs)
	return es_seo_breadcrumb_home(inputs)
});